module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr-ca":{"total snowfall":"Précipitations de neige totales","on":"oui","off":"non"}}')
  delete Component.options._Ctor
}
